import { focusManager, QueryClient } from '@tanstack/react-query';

// https://github.com/TanStack/query/discussions/6568
// React-query removed some of the focus management logic in v5
// Which resulted in some issues in the checkout flow
focusManager.setEventListener((handleFocus) => {
  const setIsFocused = () => { handleFocus(true); };
  const setIsNotFocused = () => { handleFocus(false); };

  if (typeof window !== 'undefined' && window.addEventListener) {
    window.addEventListener('focus', setIsFocused, false);
    window.addEventListener('blur', setIsNotFocused, false);

    return () => {
      window.removeEventListener('focus', setIsFocused);
      window.removeEventListener('blur', setIsNotFocused);
    };
  }

  return () => {};
});

const queryClient = new QueryClient();

export default queryClient;
